module.exports = __webpack_public_path__ + "img/memberCenterBgImage_413006.5ee07821.jpeg";